export const Types = {
  GET_LABOUR_REQUEST: 'GET_LABOUR_REQUEST',
  GET_LABOUR_SUCCESS: 'GET_LABOUR_SUCCESS',
  SET_LABOUR_ERROR: 'SET_LABOUR_ERROR',
  SET_LABOUR_SELECTION: 'SET_LABOUR_SELECTION',
  SET_LABOUR_QUAN: 'SET_LABOUR_QUAN',
  SET_LABOUR_FILTER_KEY: 'SET_LABOUR_FILTER_KEY',
  RESET_LABOURS: 'RESET_LABOURS',
  ADD_LABOURS: 'ADD_LABOURS',
}

export const getLabourRequest = (kulModelKodu, garantiTipi, hizmetKodu) => ({
  type: Types.GET_LABOUR_REQUEST,
  kulModelKodu,
  garantiTipi,
  hizmetKodu,
});

export const resetLabours = () => ({
  type: Types.RESET_LABOURS,
});

export const addLabours = (labours) => ({
  type: Types.ADD_LABOURS,
  payload: (labours)
});

export const getLabourSuccess = (response) => ({
  type: Types.GET_LABOUR_SUCCESS,
  payload: response,
});

export const setLabourError = (error) => ({
  type: Types.SET_LABOUR_ERROR,
  payload: { error }
});

export const setLabourSelection = (defect, item) => {
  return ({
    type: Types.SET_LABOUR_SELECTION,
    payload: { defect, item }
  })
};

export const setLabourQuan = (labour, value) => {
  return ({
    type: Types.SET_LABOUR_QUAN,
    payload: { labour, value }
  })
};

export const setLabourFilterKey = (value) => {
  return ({
    type: Types.SET_LABOUR_FILTER_KEY,
    payload: { value }
  })
};

